import React from 'react'
import { Container, ContainerInterno, TituloPrincipal, ListaPlanos, ItemPlano, TagMelhorOferta, TagMelhorOfertaIcone, TagMelhorOfertaTexto, BoxBorda, TagEconomia, TituloCard, ListaBonus, ListaBonusLi, PrecoDe, PrecoPor, LinkCartao, LinkBoleto } from './Styled'
import iconeMelhorOferta from 'images/renovacao-antecipada-2026/ic-melhor-oferta.png'
import { toMoney } from 'utils/helpers'

export default function Planos ({ planos }) {

	const boxCard = (data, premium = false) => {	

		return <ItemPlano>
										
			{/* Melhor Oferta */}
			<TagMelhorOferta>
				{ premium ? <React.Fragment>
					<TagMelhorOfertaIcone src={iconeMelhorOferta} />
					<TagMelhorOfertaTexto>Melhor oferta</TagMelhorOfertaTexto>
				</React.Fragment> : null }
			</TagMelhorOferta>

			{/* Box Borda */}
			<BoxBorda premium={premium}>
				
				{/* Tag Economia */}
				<TagEconomia premium={premium}>Economia de até {toMoney(data.boleto.desconto_valor)}</TagEconomia>

				{/* Título */}
				<TituloCard>{data.nome.split(" - ")[0].replace("Assinatura ", "")}</TituloCard>

				{/* Lista Bonus */}
				<ListaBonus>
					{ data.boleto.bonus ? <ListaBonusLi>+ {data.boleto.bonus} { data.boleto.bonus > 1 ? 'meses' : 'mês' } de acesso</ListaBonusLi> : null }
					{ data.boleto.mentoria ? <ListaBonusLi>+ {data.boleto.mentoria} { data.boleto.mentoria > 1 ? 'meses' : 'mês' } de Coaching Grátis</ListaBonusLi> : null }
				</ListaBonus>

				{/* Preco De */}
				{ data.cartao.preco_de ? <PrecoDe>De {data.cartao.preco_de} por</PrecoDe> : null }

				{/* Preço Por */}
				<PrecoPor>12x <strong>{data.cartao.preco_por.replace("por 12x ", "")}</strong></PrecoPor>

				{/* Link Cartão */}
				<LinkCartao href={data.cartao.link} premium={premium}>RENOVAR EM 12X S/ JUROS</LinkCartao>

				{/* Link Boleto */}
				<LinkBoleto href={data.boleto.link} premium={premium}>GANHAR +10% OFF À VISTA</LinkBoleto>

			</BoxBorda>

		</ItemPlano>
	}

	return (
		<Container>
			<ContainerInterno>

				{/* Título Principal */}
				<TituloPrincipal>RENOVE COM ANTECEDÊNCIA, ECONOMIZE E AINDA<br /> <strong>GANHE MESES EXTRAS DE ACESSO.</strong></TituloPrincipal>

				{/* Lista Planos */}
				<ListaPlanos>

					{/* Premium */}
					{ planos.map((plano) => {					
						return plano.assinaturas.map((item, index) => {
							return (
								index === 1 ? boxCard(item, true) : null
							)
						})
					})}

					{/* Básica */}
					{ planos.map((plano) => {					
						return plano.assinaturas.map((item, index) => {
							return (
								index === 0 ? boxCard(item) : null
							)
						})
					})}

				</ListaPlanos>

			</ContainerInterno>
		</Container>
	)
}
